var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconTestTube(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_51_1042)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.68659 1.45488L10.5928 4.26988M5.68659 1.45488L1.54621 8.6015C0.764547 9.95069 1.22843 11.6759 2.58231 12.4549C3.93619 13.2339 5.66739 12.7716 6.44905 11.4224L7.32131 9.9168M5.68659 1.45488L5.19899 1.16663M10.5928 4.26988L9.276 6.5428M10.5928 4.26988L11.0832 4.55214M7.32131 9.9168L8.27652 8.26801M7.32131 9.9168L5.79723 9.03993M9.276 6.5428L8.27652 8.26801M9.276 6.5428L7.78384 5.68426M8.27652 8.26801L5.82482 6.85739",
    stroke: "white",
    strokeWidth: 0.875,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8333 8.70144C12.8333 9.37263 12.311 9.9167 11.6667 9.9167C11.0223 9.9167 10.5 9.37263 10.5 8.70144C10.5 8.2815 10.9568 7.72098 11.2986 7.36024C11.5011 7.14668 11.8323 7.14668 12.0347 7.36024C12.3766 7.72098 12.8333 8.2815 12.8333 8.70144Z",
    stroke: "white",
    strokeWidth: 0.875
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_51_1042"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTestTube);
export default __webpack_public_path__ + "static/media/icon-test-tube.1c5294d55b901e0906c219c46c7f5ce8.svg";
export { ForwardRef as ReactComponent };